/**
 * 🗺️ GOOGLE PLACES COMPOSABLE
 *
 * Provides Google Places API functionality for address autocomplete and details
 * Uses RestaurantApiClient for server-side API calls
 */
import { inject } from 'vue';
export function useGooglePlaces() {
    const apiClient = inject('apiClient');
    if (!apiClient) {
        console.error('❌ RestaurantApiClient not available in useGooglePlaces');
    }
    /**
     * Get address predictions from Google Places API
     */
    const getPlacePredictions = async (input, location) => {
        if (!apiClient) {
            return {
                success: false,
                error: 'API Client not available'
            };
        }
        try {
            return await apiClient.getPlacePredictions(input, location);
        }
        catch (error) {
            console.error('❌ Error getting place predictions:', error);
            return {
                success: false,
                error: error instanceof Error ? error.message : 'Unknown error'
            };
        }
    };
    /**
     * Get detailed information for a specific place
     */
    const getPlaceDetails = async (placeId) => {
        if (!apiClient) {
            return {
                success: false,
                error: 'API Client not available'
            };
        }
        try {
            return await apiClient.getPlaceDetails(placeId);
        }
        catch (error) {
            console.error('❌ Error getting place details:', error);
            return {
                success: false,
                error: error instanceof Error ? error.message : 'Unknown error'
            };
        }
    };
    return {
        getPlacePredictions,
        getPlaceDetails
    };
}
